import "@/Services/SW";

import ReactDOM from "react-dom/client";

import App from "@/app/App";
import { setupApiClient } from "@/bootstrap";
import Root from "@/Root";

window.__PERF_OBSERVER__?.disconnect();
sessionStorage.removeItem("reload_attempts");

setupApiClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
    <Root>
        <App />
    </Root>,
);
